import AppImage from '@/components/ui/AppImage';
import Link from 'next/link';
import Icon from '@/components/ui/AppIcon';

interface GalleryItem {
  id: string;
  image: string;
  alt: string;
  vehicle: string;
  service: string;
  testimonial: string;
  client: string;
}

export default function GallerySection() {
  const galleryItems: GalleryItem[] = [
  {
    id: 'gallery_1',
    image: "https://images.unsplash.com/photo-1655038838879-180c87569c48",
    alt: 'Black Mercedes-Benz AMG with glossy PPF protection reflecting light',
    vehicle: 'Mercedes-Benz AMG GT',
    service: 'PPF Full Body + Ceramic',
    testimonial: 'La protección es invisible pero el resultado es increíble',
    client: 'Carlos M.'
  },
  {
    id: 'gallery_2',
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_1c499f068-1770155221479.png",
    alt: 'White BMW M4 with ceramic coating showing deep mirror-like shine',
    vehicle: 'BMW M4 Competition',
    service: 'Ceramic Coating 9H',
    testimonial: 'El brillo es de otro nivel, como salido de fábrica',
    client: 'Miguel R.'
  },
  {
    id: 'gallery_3',
    image: "https://images.unsplash.com/photo-1677982704894-cbfc75265ad7",
    alt: 'Red Porsche 911 GT3 with window tinting and PPF protection',
    vehicle: 'Porsche 911 GT3',
    service: 'PPF + Window Tinting',
    testimonial: 'Servicio premium, atención al detalle impecable',
    client: 'Roberto L.'
  },
  {
    id: 'gallery_4',
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_143b489f6-1770154241358.png",
    alt: 'Black Tesla Model S with full body PPF and ceramic coating',
    vehicle: 'Tesla Model S Plaid',
    service: 'Full Body Protection',
    testimonial: 'La mejor inversión para proteger mi Tesla',
    client: 'Ana P.'
  },
  {
    id: 'gallery_5',
    image: "https://images.unsplash.com/photo-1673191133439-6bfd765bfaa7",
    alt: 'Silver Audi RS6 Avant after complete detailing service',
    vehicle: 'Audi RS6 Avant',
    service: 'Auto Detailing Completo',
    testimonial: 'Quedó como nuevo, superó mis expectativas',
    client: 'Luis F.'
  },
  {
    id: 'gallery_6',
    image: "https://images.unsplash.com/photo-1699045331613-6007a689a0b5",
    alt: 'White Range Rover Sport with tinted windows and PPF protection',
    vehicle: 'Range Rover Sport',
    service: 'PPF + Tinting Premium',
    testimonial: 'Excelente trabajo, totalmente recomendado',
    client: 'Patricia G.'
  }];


  return (
    <section className="py-32 px-6 lg:px-12 bg-gradient-to-b from-black via-card to-black" id="gallery">
      <div className="max-w-[1600px] mx-auto">
        {/* Section Header */}
        <div className="text-center mb-20">
          <span className="text-primary font-heading text-sm tracking-[0.3em] mb-4 block">
            GALERÍA DE RESULTADOS
          </span>
          <h2 className="font-heading text-4xl md:text-6xl lg:text-7xl text-white mb-6 tracking-tight">
            CONFIANZA
            <br />
            <span className="text-gradient-red">COMPROBADA</span>
          </h2>
          <p className="text-white/60 text-lg md:text-xl max-w-3xl mx-auto leading-relaxed">
            Vehículos de lujo protegidos con tecnología de competición
          </p>
        </div>

        {/* Masonry Gallery */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {galleryItems.map((item, index) =>
          <div
            key={item.id}
            className="group relative rounded-[32px] overflow-hidden border border-white/10 hover:border-primary/50 transition-all duration-500 animate-scale-in"
            style={{ animationDelay: `${index * 100}ms` }}>

              {/* Image */}
              <div className="relative aspect-[4/5] overflow-hidden">
                <AppImage
                src={item.image}
                alt={item.alt}
                className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110" />

                <div className="absolute inset-0 bg-gradient-to-t from-black via-black/40 to-transparent opacity-60 group-hover:opacity-80 transition-opacity duration-500" />
              </div>

              {/* Content Overlay */}
              <div className="absolute inset-x-0 bottom-0 p-6 translate-y-0 group-hover:translate-y-0 transition-transform duration-500">
                {/* Vehicle Info */}
                <div className="mb-4">
                  <h3 className="font-heading text-white text-lg mb-1 tracking-wide">
                    {item.vehicle}
                  </h3>
                  <p className="text-primary text-sm font-medium tracking-wider">
                    {item.service}
                  </p>
                </div>

                {/* Testimonial */}
                <div className="glass-card p-4 rounded-[16px] mb-4 opacity-0 group-hover:opacity-100 transition-opacity duration-500">
                  <p className="text-white/80 text-sm leading-relaxed mb-2 italic">
                    "{item.testimonial}"
                  </p>
                  <p className="text-white/60 text-xs font-medium">
                    — {item.client}
                  </p>
                </div>
              </div>

              {/* Hover Icon */}
              <div className="absolute top-4 right-4 w-10 h-10 rounded-full bg-primary/80 backdrop-blur-md flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-500">
                <Icon name="EyeIcon" size={20} variant="outline" className="text-white" />
              </div>
            </div>
          )}
        </div>

        {/* CTA */}
        <div className="text-center mt-16">
          <Link
            href="/contact"
            className="inline-flex items-center gap-3 bg-primary hover:bg-primary/90 text-white px-12 py-5 rounded-full font-heading text-sm tracking-wider transition-all duration-300 hover:scale-105 animate-pulse-glow">

            VER MÁS PROYECTOS
            <Icon name="ArrowRightIcon" size={20} variant="outline" />
          </Link>
        </div>
      </div>
    </section>);

}